module.exports = __webpack_public_path__ + "img/u1439.3a7008d4.png";